import React, { useMemo } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../common_widgets/data-grid";
import {
  RESET_IS_SELECT_ALL_DRAFT_DOCUMENTS,
  SET_SELECTED_ESMD_DOCUMENT_LIST,
} from "./reducers/esmd-submission-reducer";
import { checkListIsEqual } from "../../mdae-framework";
import EsmdSubmissionDetails from "./esmd-submission-details";
import { isEqual } from "lodash";

const EsmdCreateSubmissionTab: React.FC<any> = () => {
  const dispatch = useDispatch();
  const draftDocumentList = useSelector(
    (state) => state["esmdSubmissionReducer"].draftDocumentList,
    checkListIsEqual
  );
  const isSelectAllDraftDocuments = useSelector(
    (state) => state["esmdSubmissionReducer"].isSelectAllDraftDocuments,
    isEqual
  );
  const currentEaRound = useSelector(
    (state) => state["externalAuditReducer"].eaAuditRounds[0],
    isEqual
  );
  const caseData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );
  const onEsmdDraftDocGridInitialized = (e) => {
    var layoutData = JSON.parse(
      localStorage.getItem(esmdDraftSubmissionGridLocalStorageKeyName)
    );
    if (layoutData) {
      delete layoutData.selectedRowKeys;
      localStorage.setItem(
        esmdDraftSubmissionGridLocalStorageKeyName,
        JSON.stringify(layoutData)
      );
    }
  };

  const esmdDraftSubmissionGridLocalStorageKeyName =
    "esmdDraftSubmissionGridLocalStorageKeyName";
  const esmdDocumentListDataGridOptions = useMemo(() => {
    return getEsmdDraftGridOption(
      onEsmdDraftDocGridInitialized,
      draftDocumentList,
      esmdDraftSubmissionGridLocalStorageKeyName
    );
  }, [draftDocumentList, isSelectAllDraftDocuments]);

  return (
    <>
      <div className="esmd-create-submission-tab">
        {draftDocumentList?.length > 0 &&
          caseData?.rqstrRecordSubmissionMethod?.toLowerCase() ===
          "esmd" && (
            <>
              <div className="green-banner">Create Submission:</div>
              <EsmdSubmissionDetails />

              <div className="top-margin">
                <MdaeDataGrid
                  {...esmdDocumentListDataGridOptions}
                  onSelectionChanged={(e) => {
                    let gridInstance = e.component;
                    var selectedRowData = gridInstance.getSelectedRowKeys();
                    dispatch({
                      type: SET_SELECTED_ESMD_DOCUMENT_LIST,
                      data: {
                        selectedEsmdSubmissionDocList: selectedRowData,
                      },
                    });
                  }}
                ></MdaeDataGrid>
              </div>
            </>
          )}
      </div>
    </>
  );
};

const getEsmdDraftGridOption = (
  onEsmdDraftDocGridInitialized,
  draftDocumentList,
  esmdDraftSubmissionGridLocalStorageKeyName
) => {
  const documentListDataGridOptions: IMdaeDataGridProps = {
    id: "grdEsmdDraftDocumentList",
    allowColumnResizing: true,
    allowColumnReordering: true,
    onInitialized: onEsmdDraftDocGridInitialized,
    mdaeColumnChooser: { isMdaeColumnChooserVisible: true },
    mdaeSearchPanel: { visible: true },
    clearFilterButtonId: "btn-esmd-draft-grid-clear-filter",
    export: { enabled: true, fileName: "EsMdDocumentList" },
    dataSource: draftDocumentList,
    filterRow: { visible: true },
    headerFilter: { visible: true },
    pageSize: 10,
    scrolling: {
      columnRenderingMode: "virtual",
    },
    selection: {
      mode: "multiple",
      showCheckBoxesMode: "always",
    },
    stateStoring: {
      enabled: true,
      type: "localStorage",
      storageKey: esmdDraftSubmissionGridLocalStorageKeyName,
    },
    mdaeColumns: [
      {
        dataField: "documentName",
        caption: "File Name",
        allowFiltering: true,
        allowSorting: true,
        fixed: false,
        allowHiding: false,
        width: 300,
      },
      {
        dataField: "fileType",
        caption: "File Type",
        allowFiltering: true,
        allowSorting: true,
        width: 80,
      },
      {
        dataField: "fileSizeDisplayName",
        calculateSortValue: "fileSize",
        caption: "File Size",
        width: 80,
        allowFiltering: false,
        allowSorting: true,
        alignment: "right",
      },
      {
        dataField: "documentCategoryName",
        caption: "Category",
        allowFiltering: true,
        allowSorting: true,
        width: 200,
      },
      {
        dataField: "attachedLevelDisplayName",
        caption: "Level",
        allowFiltering: true,
        allowSorting: true,
        width: 100,
        cellRender: (cellData) => {
          let attachedLevelName = cellData?.data.attachedLevelName;
          if (attachedLevelName?.toLowerCase() == "eac") {
            attachedLevelName = "PA Case";
          } else if (attachedLevelName?.toLowerCase() == "ea") {
            attachedLevelName = "Payer Audit";
          }
          return attachedLevelName;
        },
      },
      {
        dataField: "attachedLevelTitle",
        caption: "Level Name",
        allowFiltering: true,
        allowSorting: true,
        width: 250,
      },
      {
        dataField: "eaAuditId",
        caption: "Audit ID",
        visible: false,
        allowFiltering: true,
        allowSorting: true,
        width: 100,
      },
      {
        dataField: "createdBy",
        caption: "Uploaded By",
        allowFiltering: true,
        allowSorting: true,
        width: 150,
      },
      {
        dataField: "createDate",
        caption: "Uploaded On",
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowFiltering: true,
        allowSorting: true,
        width: 120,
      },
      {
        dataField: "updatedBy",
        caption: "Updated By",
        allowFiltering: true,
        allowSorting: true,
        width: 150,
      },
      {
        dataField: "updateDate",
        caption: "Updated On",
        dataType: "date",
        format: "MM/dd/yyyy HH:mm",
        allowFiltering: true,
        allowSorting: true,
        sortOrder: "desc",
        width: 120,
      },
      {
        dataField: "roundSubmittedSequenceNos",
        allowFiltering: true,
        allowSorting: true,
        showInColumnChooser: false,
        width: 80,
        caption: "Round Submitted",
      },
    ],
  };
  return documentListDataGridOptions;
};

export default EsmdCreateSubmissionTab;
